import React from 'react';
import {Row, Col} from 'react-bootstrap';
import '../styles/css/pro.quiztable.css';
import {Vocabulary, Pattern, Dialogue, Quiz} from './Note.Quizzes';
import {jsUcfirst} from '../util/utils';
import Moment from 'react-moment';

function QuizSelector(data, sound, handlers){
  let set_type = null;

  if (data.type === "pattern") {
    set_type = <Pattern data ={data.sets} />;
  } else if (data.type === "dialog") {
    set_type = <Dialogue data ={data.sets} />;
  } else if (data.type === "voca") {
    set_type = <Vocabulary data={data.sets} />;
  } else if (data.type === 'quiz') {
    set_type = <Quiz data={data.sets} sound={sound} handlers={handlers} />;
  }

  return set_type;
}

const QuizTable = ({data, userState, sound, handlers}) =>{
  return(
    <Row>
      <Col xs={12} md={10} mdOffset={1}>
        <span className="note_title">
          Week {data.week+1}: {jsUcfirst(data.type)}
        </span>
        {data.sets.length>0?
          <div>
            <span className="note_timestamp">
              クイズ結果:
              <Moment format="YYYY-MM-DD hh:mm">
                {data.date}
              </Moment>
            </span>
            {QuizSelector(data, sound, handlers)}
          </div>:
          userState==='pro'?
          <div>
            <span className="note_timestamp">クイズを進行し、その結果を下から確認してください。</span>
          </div>:
          <div className="empty-pt">
            <span>
              本機能はプレミアム会員専用の機能です。プレミアムにアップグレードしますと、より多くの学習機能がご利用できます。
            </span>
            <a className="btn-upgrade" href="http://edge.themusio.com/intro#section_p5">
              Premiumにアップグレード
            </a>
          </div>
        }
      </Col>
    </Row>
  );
};

export default QuizTable;



// WEBPACK FOOTER //
// ./src/components/Note.QuizTable.js